import { createContext } from 'react';

var SubMenuInitialFocus;
(function (SubMenuInitialFocus) {
  SubMenuInitialFocus["First"] = "first";
  SubMenuInitialFocus["Last"] = "last";
  SubMenuInitialFocus["Target"] = "target";
  SubMenuInitialFocus["None"] = "none";
})(SubMenuInitialFocus || (SubMenuInitialFocus = {}));
var SubMenuContext = /*#__PURE__*/createContext({});

export { SubMenuContext, SubMenuInitialFocus };
